import { render, staticRenderFns } from "./CreateAd.vue?vue&type=template&id=24dd3bd0&scoped=true"
import script from "./CreateAd.vue?vue&type=script&lang=js"
export * from "./CreateAd.vue?vue&type=script&lang=js"
import style0 from "./CreateAd.vue?vue&type=style&index=0&id=24dd3bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd3bd0",
  null
  
)

export default component.exports